import { StaticImageData } from 'next/image'
import { LINKS } from 'routes/constants'
import ImportDataFromExternalApp1x from 'routes/Solutions/ImportFromExternalApp/import-from-external-app-desk@1x.avif'
import ImportDataFromExternalApp2x from 'routes/Solutions/ImportFromExternalApp/import-from-external-app-desk@2x.avif'
import OneClickIntegrations1x from 'routes/Solutions/OneClickIntegrations/one-click-integrations-mob@1x.avif'
import OneClickIntegrations2x from 'routes/Solutions/OneClickIntegrations/one-click-integrations-mob@2x.avif'
import PushDataToExternalApps1x from 'routes/Solutions/PushDataToExternalApp/push-data-desk@1x.avif'
import PushDataToExternalApps2x from 'routes/Solutions/PushDataToExternalApp/push-data-desk@2x.avif'
import InAppWorkflowBuilder1x from 'routes/Solutions/InAppWorkflowBuilder/workflow-builder@1x.avif'
import InAppWorkflowBuilder2x from 'routes/Solutions/InAppWorkflowBuilder/workflow-builder@2x.avif'
import RealTimeDataSync1x from 'routes/Solutions/RealtimeDataSync/data-sync-desk@1x.avif'
import RealTimeDataSync2x from 'routes/Solutions/RealtimeDataSync/data-sync-desk@2x.avif'
import MigrationFromOtherApps1x from 'routes/Solutions/Migration/data-migration-desk@1x.avif'
import MigrationFromOtherApps2x from 'routes/Solutions/Migration/data-migration-desk@2x.avif'

export type LandingSolutionsDataType = {
  image1x: StaticImageData
  image2x: StaticImageData
  title: string
  description: string
  href: string
}

export const landingSolutionsData: LandingSolutionsDataType[] = [
  {
    image1x: ImportDataFromExternalApp1x,
    image2x: ImportDataFromExternalApp2x,
    title: 'Import Data from External App',
    description:
      'Let users explore external data and sync what matters to your app.',
    href: LINKS.SOLUTIONS.IMPORT_FROM_EXTERNAL_APP,
  },
  {
    image1x: OneClickIntegrations1x,
    image2x: OneClickIntegrations2x,
    title: 'One-Click Integrations',
    description:
      'Enable one-click integrations with scalable blueprints that work across customers and apps.',
    href: LINKS.SOLUTIONS.ONE_CLICK_INTEGRATIONS,
  },
  {
    image1x: PushDataToExternalApps1x,
    image2x: PushDataToExternalApps2x,
    title: 'Push Data to External Apps',
    description:
      'Let your users navigate data in external app: files, people, companies, etc.',
    href: LINKS.SOLUTIONS.PUSH_DATA_TO_EXTERNAL_APPS.URL,
  },
  {
    image1x: InAppWorkflowBuilder1x,
    image2x: InAppWorkflowBuilder2x,
    title: 'In-app Workflow Builder',
    description:
      'Let your users build custom automation, and integration workflows right inside your app.',
    href: LINKS.SOLUTIONS.IN_APP_WORKFLOW_BUILDER,
  },
  {
    image1x: RealTimeDataSync1x,
    image2x: RealTimeDataSync2x,
    title: 'Real-Time Data Sync',
    description:
      'Import all the data of a given type from an external app, and keep it in sync.',
    href: LINKS.SOLUTIONS.REALTIME_DATA_SYNC.URL,
  },
  {
    image1x: MigrationFromOtherApps1x,
    image2x: MigrationFromOtherApps2x,
    title: 'Migration from Other Apps',
    description:
      "Import all of your new customer's data from another application.",
    href: LINKS.SOLUTIONS.MIGRATION_FROM_OTHER_APPS,
  },
]
